
export default function Flow() {
  const steps = [
    { number: '1', title: '無料登録', icon: 'ri-user-add-line' },
    { number: '2', title: '面談', icon: 'ri-discuss-line' },
    { number: '3', title: '案件紹介', icon: 'ri-file-list-3-line' },
    { number: '4', title: 'プロジェクト参画', icon: 'ri-rocket-line' }
  ];

  return (
    <section id="flow" className="py-12 bg-[#0d1b2e]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
          ご利用の流れ
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-4 gap-4">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-[#1a2f4e] p-4 rounded-lg text-center border border-slate-700">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-2 bg-amber-500 text-[#0a1628] rounded-full font-bold text-lg">
                    {step.number}
                  </div>
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                    <i className={`${step.icon} text-3xl text-amber-400`}></i>
                  </div>
                  <p className="font-semibold text-sm text-white">{step.title}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-2 transform -translate-y-1/2 translate-x-1/2">
                    <i className="ri-arrow-right-line text-2xl text-amber-400"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}